import React                         from 'react';
import moment                        from 'moment';
import Parse                         from 'html-react-parser';
import Grid                          from '@mui/material/Grid';
import AccessTimeFilledIcon          from '@mui/icons-material/AccessTimeFilled';

export default function Exhibit (props) {
	const { data } = props;

	const convertStringToHtml = (d) => {
		if (!d || !d.length)
			return;

		const html = Parse (d);
		return html;
	}

	return (
		<>
			<h1 style={{color: "black", fontSize: '28px'}}>{data.title}</h1>
			<img
				src={data.img}
				alt={data.img_alt}
				style={{width: '100%'}}
			/>
			<div>
				{convertStringToHtml (data.text)}
			</div>
			<hr
				style={{
					background: 'indigo',
					height: '1px',
				}}
			/>
			<Grid container spacing={2}>
				<Grid item xs={12} md={8}>
						{ data.tags && data.tags.length && data.tags.map ((t, index) => (
							<span className='chip'>#{t}</span>
						))}
				</Grid>
				<Grid item xs={12} md={4}>
					<span className='readTimestamp'>
					<AccessTimeFilledIcon />
					&nbsp;
					{moment (data.updatedAt).format ('DD.MM.YYYY')}
					</span>
				</Grid>
			</Grid>
		</>
	);
}
